import { mapGetters, mapActions } from 'vuex';
import mvtCollapse from '@/common/components/mvtcollapse/mvt-collapse.vue';
import mvtEstPriceChart from '@/common/components/mvtestprice/mvt-estpricechart.vue';

export default {
    name: 'propertyEstimate',
    inject: ['$eventBus'],
    components: {
        mvtCollapse,
        mvtEstPriceChart,
    },
    props: ['disableCollapse', 'isActive', 'isMarket5YLoaded'],
    computed: {
        ...mapGetters('glb', ['glb']),
        ...mapGetters('dpp', ['dpp', 'getEstRentFee', 'getEstimatePriceRange', 'getEstimateInfo']),
        priceChanged() {
            return this.dpp.forecast && this.dpp.forecast.lastMonthPrice && this.estPrice ? this.estPrice - this.dpp.forecast.lastMonthPrice : 0;
        },
        isIncrease() {
            return this.priceChanged > 0;
        },
        hasChartData() {
            return this.dpp.market5Y?.dailyCityStatisticsList?.length;
        }
    },
    mounted() {
        if (this.disableCollapse || this.isActive) {
            this.ensureFiveYearMarketTrend();
        }
    },
    methods: {
        ...mapGetters('glb', ['getComplianceMethod']),
        ...mapActions('dpp', ['fetchMarketChartData']),
        showNotSupportedByMLS() {
            const compliance = this.getComplianceMethod()();
            return compliance?.[0]?.rule?.includes('showNotSuportByMLS');
        },
        /** Same API as market statistics chart; deferred until expand so `hasChartData` can enable the estimate chart. */
        ensureFiveYearMarketTrend() {
            if (!this.dpp?.geo) return;
            if (this.dpp.market5Y?.dailyCityStatisticsList?.length) return;
            this.fetchMarketChartData({
                cityId: this.dpp.geo.cityId,
                countyId: this.dpp.geo.countyId,
                neighborhoodId: this.dpp.geo.neighborhoodId,
                zipcode: this.dpp.geo.zipcode,
                isFiveYear: true,
            });
        },
        onEstimateCollapseOpen() {
            this.ensureFiveYearMarketTrend();
        },
    },
};
